import { render, staticRenderFns } from "./D003.vue?vue&type=template&id=bb303a20&scoped=true&"
import script from "./D003.vue?vue&type=script&lang=js&"
export * from "./D003.vue?vue&type=script&lang=js&"
import style0 from "./D003.vue?vue&type=style&index=0&id=bb303a20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb303a20",
  null
  
)

export default component.exports